// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"22af9042","513":"8d59cad7"}[chunkId] + ".chunk.js";
};